import { Cellar, Passage, Room } from '..';
import { Direction } from '../../../parse';
import { EntitySpec } from '../../game';
import { Slide } from '../../items';
import { InASlide2 } from '../InASlide2';
import { SootyRoom } from '../SootyRoom';

export class SlideLedge extends Room {
    static spec(): EntitySpec<SlideLedge> {
        return {
            ref: 'slide-ledge',
            constructor: SlideLedge,
            initial: {
                contents: [Slide.spec().ref],
                hasBeenVisited: false,
                hasBeenDescribed: false,
            },
            nouns: [],
            adjectives: [],
            handlers: [],
        };
    }

    ref() {
        return SlideLedge.spec().ref;
    }

    name(): string {
        return 'Slide Ledge';
    }

    description(): string {
        return (
            'This is a narrow ledge abutting the coal chute, in which ' +
            'a rope can be seen passing downward. Behind you, to the south, is a small room.'
        );
    }

    isNaturallyLit(): boolean {
        return false;
    }

    isSacred(): boolean {
        return true;
    }

    passages(): Passage[] {
        return [
            new Passage({ via: Direction.Up, to: InASlide2.spec().ref }),
            new Passage({ via: Direction.South, to: SootyRoom.spec().ref }),
            new Passage({
                via: Direction.Down,
                to: Cellar.spec().ref,
            }),
        ];
    }
}
